export default __webpack_public_path__ + "static/media/1.1f59295c.jpg";